import { apiEndpoints } from 'apiService';
import { ALL_CATEGORIES, ALL_TAGS } from './metadata';
import { httpClient } from 'ajax';

export function adaptCategories(response) {
    if (!response.data) {
        return [];
    }

    return response.data.map((categ) => {
        return {
            id: categ.id,
            siteId: categ.relationships.site.data.id,
            title: categ.attributes.title,
            slug: categ.attributes.slug,
            domain: categ.attributes.domain,
            pageId: categ.relationships.page.data.id,
            url: categ.attributes.absolute_url
        };
    });
}

export function adaptTags(response) {
    if (!response.data) {
        return [];
    }

    return response.data.map((tag) => {
        return {
            id: tag.id,
            title: tag.attributes.name
        };
    });
}

export function adaptEntries(response, categories = []) {
    function findCategoriesByIds(categoriesIds) {
        const availableCategories = Array.isArray(categories) ? categories : [];
        return availableCategories.filter((category) => categoriesIds.includes(category.id));
    }

    return response.data.map((entry) => {
        const {
            title,
            short_description,
            publication_date,
            custom_publication_date,
            tags,
            authors_displayname,
            poster_image,
            absolute_url,
            show_image,
            show_social_icons,
            show_post_date,
            show_author,
            image_alt_text,
            meta_info: { page, component } = {}
        } = entry.attributes;
        const categoriesIds = entry.relationships.categories.data.map((category) => category.id);
        let categories = findCategoriesByIds(categoriesIds) || [];
        return {
            id: entry.id,
            title: title,
            content: short_description,
            date: custom_publication_date || publication_date,
            tags: tags,
            categories: categories,
            author: authors_displayname,
            image: poster_image,
            url: absolute_url,
            imageAltText: image_alt_text,
            entryShowImage: show_image,
            entryShowPostDate: show_post_date,
            entryShowAuthor: show_author,
            entryShowSocialIcons: show_social_icons,
            pageId: page,
            componentId: component
        };
    });
}

export function adaptEntry(response, categories) {
    const {
        title,
        short_description,
        publication_date,
        tags,
        authors_displayname,
        poster_image,
        absolute_url,
        show_image,
        show_post_date,
        show_author,
        image_alt_text,
        show_social_icons,
        meta_info: { page, component } = {}
    } = response.data.attributes;
    const categoriesIds = response.data.relationships.categories.data.map(
        (category) => category.id
    );
    let filteredCategories = categories.filter((category) => categoriesIds.includes(category.id));
    return (
        categories && {
            id: response.data.id,
            title: title,
            content: short_description,
            date: publication_date,
            tags: tags,
            categories: filteredCategories,
            author: authors_displayname,
            image: poster_image,
            url: absolute_url,
            imageAltText: image_alt_text,
            entryShowImage: show_image,
            entryShowPostDate: show_post_date,
            entryShowAuthor: show_author,
            entryShowSocialIcons: show_social_icons,
            pageId: page,
            componentId: component
        }
    );
}

export function fetchEntries(
    currentPage = 1,
    itemsPerPage = 15,
    filters = {},
    ordering = '-publication_date',
    title = '',
    siteId = ''
) {
    const { categories } = filters || [];
    const { tags } = filters || [];
    const hasAllCategories =
        Array.isArray(categories) &&
        categories.findIndex((categ) => categ.id === ALL_CATEGORIES.id) > -1;
    const hasAllTags = tags.findIndex((tag) => tag.id === ALL_TAGS.id) > -1;
    const categoryIds = hasAllCategories ? '' : categories.map((c) => c.id).join(',');
    let tagIds = hasAllTags ? '' : tags.map((t) => t.id).join(',');

    return httpClient({
        method: 'GET',
        url: apiEndpoints.BLOG_ENTRIES.replace('{category_ids}', categoryIds)
            .replace('{tag_ids}', tagIds)
            .replace('{page_size}', itemsPerPage)
            .replace('{page}', currentPage)
            .replace('{title}', title)
            .replace('{ordering}', ordering)
            .replace('{site_ids}', siteId),
        dataType: 'json',
        cache: false
    }).fail((xhr, status, err) => {
        console.error('Failed to get blog entries', xhr, status, err);
    });
}

export function fetchEntry(id, siteId = '') {
    return httpClient({
        method: 'GET',
        url: apiEndpoints.BLOG_ENTRY.replace('{blogEntryId}', id).replace('{site_ids}', siteId),
        dataType: 'json',
        cache: false
    }).fail((xhr, status, err) => {
        console.error('Failed to get blog entry', xhr, status, err);
    });
}

export function fetchCategories(siteId = '') {
    return httpClient({
        method: 'GET',
        url: apiEndpoints.BLOG_CATEGORIES.replace('{site_ids}', siteId),
        dataType: 'json',
        cache: false
    }).fail((xhr, status, err) => {
        console.error('Failed to get blog categories', xhr, status, err);
    });
}

export function fetchTags(siteId = '') {
    return httpClient({
        method: 'GET',
        url: apiEndpoints.BLOG_TAGS.replace('{tagName}', '')
            .replace('{page_size}', '')
            .replace('{page}', '')
            .replace('{site_ids}', siteId),
        dataType: 'json',
        cache: false
    }).fail((xhr, status, err) => {
        console.error('Failed to get blog tags', xhr, status, err);
    });
}
